<template>
	<div class="ibox float-e-margins ibox-content" style="position: relative; height: 100%;" id="editPanel">
		<div class="form-horizontal">
			<div class="form-group">
				<!--<label class="col-sm-1 control-label t_center red">设备类型ID</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-bind:readonly="mode=='check'" v-model.trim="editItem.categoryId">
				</div>-->
				<label class="col-sm-1 control-label t_center red">*设备品牌名称</label>
				<div class="col-sm-3">
					<select class="form-control" v-model="editItem.brandCode" v-bind:disabled="mode=='check'">
						<option v-for="option in deviceNameTypes" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center red">*设备类型编号</label>
				<div class="col-sm-3">
					<input type="text" class="form-control"  v-model.trim="editItem.categoryNo" v-bind:readonly="mode=='check'">
				</div>					
				<label class="col-sm-1 control-label t_center red">*里程类型</label>
				<div class="col-sm-3">					
					<select class="form-control" v-model="editItem.mileageType" v-bind:disabled="mode=='check'">
						<option v-for="option in mileageTypes" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>	
			<div class="form-group">
				<label class="col-sm-1 control-label t_center red">*设备类型</label>
				<div class="col-sm-3">					
					<select class="form-control" v-model="editItem.obdFlag" v-bind:disabled="mode=='check'">
						<option v-for="option in obdFlags" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
				<label class="col-sm-1 control-label t_center red">*有线无线</label>
				<div class="col-sm-3">					
					<select class="form-control" v-model="editItem.wifiFlag" v-bind:disabled="mode=='check'">
						<option v-for="option in wifiFlags" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">创建时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="editItem.createTime" readonly>
				</div>
				<label class="col-sm-1 control-label">修改时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="editItem.updateTime" readonly>
				</div>
			</div>
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<button v-show="mode!=='check'" class="btn btn-primary" @click="update">确定</button>
					<button class="btn btn-primary" @click="close">关闭</button>
				</div>
			</div>
		</div>
		
		<!--   弹出框子组件        -->
		<sub-modal ref="modalMsg" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>	
		<sub-modal ref="modalWarn" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModalMsg">确定</button>
			</div>
		</sub-modal>
	</div>
</template>

<script>
    import SubModal from 'components/common/SubModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	export default {
		name: 'PageDeviceTypeEdit',
		components: {
		   SubModal
		},
		props: ["editItem", "deviceNameTypes","mileageTypes", "obdFlags","wifiFlags","mode"],
		data() {
			return {				
				tipContent: '11',
				scrollTop: '',
				messageStr:''
			}

		},
//		watch :{
//			editItem(val){
//				this.dataInfo=val;
//			}
//		},
		methods: {
			close(action) {
				this.$emit('toClose', action);
			},
			update() {
				if(this.mode == 'edit') {
					this.$http.put(process.env.API_ROOT + '/system/category/' + this.editItem.id, this.editItem)
						.then(res => {
							if(!res.data.success) {
								this.openMsgTip(res.data.message)
							}else
							this.close('refresh');
						},res => {
							this.openMsgTip(res.body.message);
							this.loadingstatus = false;
					}).catch(res => {
							this.openMsgTip(OPERATE_EXCEPTION);
						})
				}
				if(this.mode == 'create') {
					this.$http.post(process.env.API_ROOT + '/system/category/', this.editItem)
						.then(res => {
							if(!res.data.success) {
								this.openMsgTip(res.data.message)
							}else
							this.close('refresh');
						},res => {
							this.openModalMsg('modalWarn','标红部分为必填项');
							this.loadingstatus = false;
					}).catch(res => {
							this.openModalMsg(OPERATE_EXCEPTION);
						})
				}

			},
			// 消息弹出框相关 
			closeMsgTip() {
				this.$refs.modalMsg.close();
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsg.open();
			},
			openModalMsg(ref,msg){
				this.messageStr=msg;
				this.$refs[ref].open();
			},
			closeModalMsg() {
				this.$refs.modalWarn.close();
			},

		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PageDeviceTypeEdit.vue?24b26d74